document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-card").forEach((card) => {
    const currentSwatch = card.querySelectorAll(".block-swatch");
    const linkCard = card.querySelector(".product-card__media");

    currentSwatch.forEach((element) => {
      element.addEventListener("click", () => {
        setTimeout(() => {
          const wishlistBtn = card.querySelector(".th_prd_wl_btn");
          const href = linkCard.getAttribute("href");

          if (!href) return;

          const params = new URLSearchParams(href.split("?")[1]);
          const variantId = params.get("variant");

          if (variantId) {
            wishlistBtn.dataset.variant_id = variantId;
          }
        }, 100);
      });
    });
  });
});

/* PRODUCT PAGE DETAIL */
/* GESTIONE DESCRIZIONE LEGGI DI PIÙ */
const productDescription = document.querySelector(".js-product-description");
const productShowMore = document.querySelector(".js-show-more");
if (productDescription && productShowMore) {
  const labelMore = productShowMore.dataset.labelMore;
  const labelLess = productShowMore.dataset.labelLess;

  if (productDescription.scrollHeight <= productDescription.clientHeight) {
    productShowMore.style.display = "none";
  }
  productShowMore.addEventListener("click", () => {
    productDescription.classList.toggle("clamp-description");
    productShowMore.textContent = !productDescription.classList.contains(
      "clamp-description"
    )
      ? labelLess
      : labelMore;
  });
}

/* GESTIONE CUSTOM WRAP */
document.addEventListener("DOMContentLoaded", function () {
  const wrapSection = document.querySelector("#plg-wrap-position");
  const wrapContainer = document.querySelector("#plg-wrap-container");

  if (wrapSection && wrapContainer) {
    wrapSection.appendChild(wrapContainer);
    wrapContainer.style.display = "block";
  }

  const triggerMoreInfo = document.querySelector("#js-trigger-moreinfo");
  const customWrap = document.querySelector(".plg-custom-wrap");

  // Aggiungo la classe al click
  triggerMoreInfo?.addEventListener("click", () => {
    customWrap.classList.toggle("is-open");
  });

  const wrapSlider = document.querySelector(".js-wrap");

  new Swiper(wrapSlider, {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Gestione validazione campi messaggio/firma
  const messageInput = document.querySelector(".plg-text-area textarea");
  const senderInput = document.querySelector(".plg-sender-input input");
  const termsCheckbox = document.querySelector("#terms-checkbox");
  const giftWrapCheckbox = document.querySelector("#gift-wrap-checkbox");
  const buyButtons = document.querySelector(".buy-buttons");
  const requiredField = document.querySelector("#required-field");
  let hasContent = false;

  function checkFields() {
    // Verifica se almeno uno dei campi è compilato
    const messageHasValue = messageInput && messageInput.value.trim() !== "";
    const senderHasValue = senderInput && senderInput.value.trim() !== "";
    hasContent = messageHasValue || senderHasValue;

    if (hasContent) {
      if (giftWrapCheckbox) {
        giftWrapCheckbox.checked = true;
        giftWrapCheckbox.classList.add("is-locked");
      }
      if (termsCheckbox && termsCheckbox.checked) {
        requiredField.style.display = "none";
      } else {
        requiredField.style.display = "block";
      }
    } else {
      if (giftWrapCheckbox) {
        giftWrapCheckbox.classList.remove("is-locked");
      }
      requiredField.style.display = "none";
    }
  }

  // Previeni la deselezione quando è locked
  if (giftWrapCheckbox) {
    giftWrapCheckbox.addEventListener("click", function (e) {
      if (this.classList.contains("is-locked") && !this.checked) {
        e.preventDefault();
        this.checked = true;
      }
    });
  }

  // Gestione click sul pulsante quando disabilitato
  if (buyButtons) {
    buyButtons.addEventListener("click", function (e) {
      if (hasContent && termsCheckbox && !termsCheckbox.checked) {
        e.preventDefault();
        requiredField.style.display = "block";
        termsCheckbox.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    });
  }

  // Ascolta i cambiamenti sui campi
  if (messageInput) {
    messageInput.addEventListener("input", checkFields);
  }

  if (senderInput) {
    senderInput.addEventListener("input", checkFields);
  }

  if (termsCheckbox) {
    termsCheckbox.addEventListener("change", checkFields);
  }

  // Check iniziale
  checkFields();
});
/* GESTIONE T&C DRAWER */
document.addEventListener("DOMContentLoaded", function () {
  const cartDrawer = document.querySelector("#cart-drawer");

  if (cartDrawer) {
    const firmaDrawer = cartDrawer.querySelector(".plg-drawer-firma input");
    const noteDrawer = cartDrawer.querySelector(
      ".plg-drawer-messaggio textarea"
    );
    const termsCheckboxWrapper = cartDrawer.querySelector(
      "#terms-message-wrapper"
    );
    const termsCheckbox = cartDrawer.querySelector("#terms-checkbox-drawer");

    // Check iniziale al caricamento
    checkDrawerFields();

    function checkDrawerFields() {
      const messageHasValue = noteDrawer.value.trim() !== "";
      const senderHasValue = firmaDrawer.value.trim() !== "";
      const hasContent = messageHasValue || senderHasValue;

      if (hasContent) {
        termsCheckboxWrapper.style.display = "block";
        termsCheckbox.required = true;
      } else {
        termsCheckboxWrapper.style.display = "none";
        termsCheckbox.required = false;
      }
    }

    // Aggiungi listener
    firmaDrawer.addEventListener("input", checkDrawerFields);
    firmaDrawer.addEventListener("change", checkDrawerFields);
    noteDrawer.addEventListener("input", checkDrawerFields);
    noteDrawer.addEventListener("change", checkDrawerFields);
  }
});

/* CART CUSTOM ATTRIBUTE - Salvataggio automatico messaggio personalizzato */
document.addEventListener("DOMContentLoaded", function () {
  const cartNoteElements = document.querySelectorAll("cart-note");

  cartNoteElements.forEach((cartNote) => {
    cartNote.addEventListener("change", handleAttributeUpdate);
    cartNote.addEventListener("input", debounce(handleAttributeUpdate, 500));
  });

  function handleAttributeUpdate(event) {
    const target = event.target;
    const name = target.getAttribute("name");

    if (!name) return;

    // Gestisce le note standard
    if (name === "note") {
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: target.value }),
        keepalive: true,
      });
    }
    // Gestisce gli attributi personalizzati
    else if (name.startsWith("attributes[")) {
      const attributeName = name.match(/attributes\[(.*?)\]/)?.[1];

      if (attributeName) {
        const attributes = {};
        attributes[attributeName] = target.value;

        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes }),
          keepalive: true,
        })
          .then((response) => response.json())
          .then((data) => {
            console.log("Attributo salvato:", attributeName, target.value);

            // SINCRONIZZA tutti gli altri campi con lo stesso name
            syncAttributeFields(name, target.value, target);
          })
          .catch((error) => {
            console.error("Errore nel salvataggio:", error);
          });
      }
    }
  }

  // Sincronizza tutti i campi con lo stesso attributo (drawer <-> main-cart)
  function syncAttributeFields(attributeName, value, excludeElement) {
    const allFields = document.querySelectorAll(`[name="${attributeName}"]`);

    allFields.forEach((field) => {
      // Non aggiornare il campo che ha triggerato l'evento
      if (field !== excludeElement && field.value !== value) {
        field.value = value;
      }
    });
  }

  // Funzione di debounce
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const cartPage = document.querySelector(".shopify-section--main-cart");
  if (cartPage) {
    const customMessage = document.querySelector(
      ".plg-cart-messaggio textarea"
    );
    const customSignature = document.querySelector(".plg-cart-firma input");
    const customTC = document.querySelector("#terms-checkbox");

    function checkCartFields() {
      console.log("entro");

      const customMessageValue = customMessage.value.trim() !== "";
      const customSignatureValue = customSignature.value.trim() !== "";
      const hasContent = customMessageValue || customSignatureValue;

      if (hasContent) {
        customTC.required = true;
      } else {
        customTC.required = false;
      }
    }

    // Aggiungi listener
    customMessage.addEventListener("input", checkCartFields);
    customMessage.addEventListener("change", checkCartFields);
    customSignature.addEventListener("input", checkCartFields);
    customSignature.addEventListener("change", checkCartFields);

    checkCartFields();
  }
});

document.addEventListener("DOMContentLoaded", () => {

  /* featured search */
const featuredSearch = document.querySelector(".js-featured-search");
if(featuredSearch) {
  
    const nextBtn = featuredSearch.querySelector('.prev-next-button--next')
    const prevBtn = featuredSearch.querySelector('.prev-next-button--prev')
  new Swiper(featuredSearch, {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    breakpoints: {
       1024: {
        slidesPerView: 5,
      },
  }
  });
}

  /* featured cart */
  const featuredCart = document.querySelector(".js-featured-cart");

  if(featuredCart) {
    /* const nextBtn = featuredCart.querySelector('.prev-next-button--next')
    const prevBtn = featuredCart.querySelector('.prev-next-button--prev') */

  new Swiper(featuredCart, {
    slidesPerView: 1,
    spaceBetween: 10,
    direction: "vertical",
    breakpoints: {
      /* 768: {
        slidesPerView: 1.5,
      }, */
      /* 1366: {
        slidesPerView: 1.5,
      } */
    },
    /* navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    }, */
  });}
});



document.addEventListener('variant:change', function(event) {
  const placeholder = document.querySelector('[data-wysh-product-button-placeholder]');

  if (!placeholder) return;

  if (event.detail.variant && event.detail.variant.available) {
    placeholder.style.display = '';
  } else {
    placeholder.style.display = 'none';
  }
});